<div [style.--height]="height" class="skymiles-landing-page-menu">
  <div
    #scrolledToElement="idpStickyNavbar"
    [class.skymiles-landing-page-menu__reached]="
      scrolledToElement.reached || current.toggle
    "
    idpStickyNavbar
  >
    <idp-navbar [current]="current"></idp-navbar>
    <div *ngIf="current.toggle" class="skymiles-landing-page-menu__sections">
      <div *ngFor="let section of sections; let sectionIndex = index">
        <idp-section
          (listItem)="updateLabelAndUrl($event)"
          [details]="section"
        ></idp-section>
        <div
          *ngIf="sectionIndex !== sections.length - 1"
          class="skymiles-landing-page-menu__sections__divider"
        ></div>
      </div>
    </div>
  </div>
</div>
